import React from 'react'
import {
  IProps as IMiniTestimonials,
  TestimonialMini,
} from 'marketing-site/src/library/components/TestimonialMini'
import { IMiniTestimonials as IContentfulMiniTestimonials } from 'marketing-site/@types/generated/contentful'
import { transformTestimonialMiniCard } from '../elements/ContentfulTestimonialMiniCard'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { getHexColorFromName } from 'marketing-site/src/library/utils'

export const ContentfulMiniTestimonials = (miniTestimonials: IContentfulMiniTestimonials) => (
  <EntryMarker entry={miniTestimonials}>
    {() => <TestimonialMini {...transformMiniTestimonials(miniTestimonials)} />}
  </EntryMarker>
)

export function transformMiniTestimonials({
  fields,
}: IContentfulMiniTestimonials): IMiniTestimonials {
  return {
    testimonials: fields.testimonials.map(transformTestimonialMiniCard),
    bgColor: fields.bgColor && getHexColorFromName(fields.bgColor),
    withMagicSparkles: fields.withMagicSparkles && fields.withMagicSparkles,
  }
}
